import { CryptoCurrencyID } from "../constants";
import { formatDecimals } from "../currencies";
import useCurrencyRate from "./useCurrencyRate";

export const getCryptoInUSD = (amount?: number | string, rate?: number) => {
  if (!amount || !rate) return null;

  if (amount == "<0.0001") return "<0.01";

  const price = rate * +amount;

  return formatDecimals(price, 2);
};

const useCryptoInUSD = (
  amount?: number | string,
  currencyId = CryptoCurrencyID.ETH,
) => {
  const { data, isLoading } = useCurrencyRate(currencyId);

  return {
    cryptoInUSD:
      amount && data?.price ? getCryptoInUSD(amount, data.price) : null,
    isLoading,
  };
};

export default useCryptoInUSD;
